import { render, staticRenderFns } from "./Fund-Manager.vue?vue&type=template&id=556c26cc&scoped=true&"
import script from "./Fund-Manager.vue?vue&type=script&lang=js&"
export * from "./Fund-Manager.vue?vue&type=script&lang=js&"
import style0 from "./Fund-Manager.vue?vue&type=style&index=0&id=556c26cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556c26cc",
  null
  
)

export default component.exports